import AcTransactionDetailsDetailsTab from './details/details';
import AcTransactionDetailsChangelogTab from './changelog/changelog';

export default {
  Details: AcTransactionDetailsDetailsTab,
  Changelog: AcTransactionDetailsChangelogTab,
};
